import React from 'react';
import { useAuth } from '../context/AuthContext';
import './ProfilePage.css';

const ProfilePage = ({ onLogout }) => {
  const { user } = useAuth();

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-avatar">
          {user?.name?.split(' ').map(n => n[0]).join('') || 'DM'}
        </div>
        <h1>{user?.name || 'Dante Moss'}</h1>
        <p>{user?.email || 'user@example.com'}</p>
      </div>

      <div className="profile-actions">
        <div className="action-card">
          <h3>Personal Information</h3>
          <p>Actualiza tus datos personales</p>
          <button className="action-btn">Editar</button>
        </div>

        <div className="action-card">
          <h3>Metodos de pago</h3>
          <p>Gestiona tus opciones de pago</p>
          <button className="action-btn">Administrar</button>
        </div>

        <div className="action-card">
          <h3>Historial pedidos</h3>
          <p>Pedidos anteriores</p>
          <button className="action-btn">Ver</button>
        </div>

        <div className="action-card">
          <h3>Preferencias</h3>
          <p>Personalizar experiencia</p>
          <button className="action-btn">Ajustes</button>
        </div>
      </div>

      <div className="logout-section">
        <button className="logout-btn" onClick={onLogout}>
          Log Out
        </button>
      </div>
    </div>
  );
};

export default ProfilePage;